module.exports = __webpack_public_path__ + "img/00051.ed95ed1c.webp";